export const zahtjev_prijenos= {
  templateId: 96,
  category: 9,
  templateTitle: "Zahtjev za prijenos podataka - GDPR",
  templateDescription: `<p>Zahtjev za prijednos podataka je pravo ispitanika koje proizlazi iz Uredbe, čije nepoštivanje od strane voditelja obrade je kažnjivo.</p>`,
  description: `
    <h5>OPIS  DOKUMENTA</h5>
    <p>Ispitanik ima pravo zaprimiti osobne podatke koji se odnose na njega, a koje je pružio voditelju obrade u strukturiranom, uobičajeno upotrebljavanom i strojno čitljivom formatu te ima pravo prenijeti te podatke drugom voditelju obrade bez ometanja od strane voditelja obrade kojem su osobni podaci pruženi, ako su ispunjeni uvjeti određeni Općom Uredbom o zaštiti podataka.</p>
    <p>Napomena: ovaj dokument se ispunjava tek nakon ispisa na pisaču.</p>
    
    <h5>PRAVNA OSNOVA</h5>
    <p>UREDBA (EU) 2016/679 EUROPSKOG PARLAMENTA I VIJEĆA od 27. travnja 2016. o zaštiti pojedinaca u vezi s obradom osobnih podataka i o slobodnom kretanju takvih podataka te o stavljanju izvan snage Direktive 95/46/EZ (Opća uredba o zaštiti podataka).</p>
    `,
    sides: [
      {
          prefix: 'Na temelju Opće uredbe o zaštiti podataka,',

          signature: "Podnositelj zahtjeva:",
            inputs: [{
              type: "input",
              required: true,
              placeholder: "Ime i prezime",
            },
            {
              type: "input",
              required: false,
              placeholder: "Ulica i kućni broj",
            },
            {
              type: "input",
              required: false,
              placeholder: "Mjesto",
            },
            ],
      }
  ],

  headline: "podnosim sljedeći",
  title: "ZAHTJEV ZA PRIJENOS PODATAKA",

  noArticleNumbers: true,

  articles: [  
    
    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
                    { type: "text", content: "1. VODITELJ OBRADE:\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "NAZIV: _________________________\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "SJEDIŠTE: _________________________\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "ADRESA: _________________________\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "OIB: _________________________"},
        
          ],
        }
      ]
    }, 
    
    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
                    { type: "text", content: "2. RAZLOG PRIJENOSA PODATAKA (označiti odabir):\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: " □ obrada se temelji na privoli za obradu svojih osobnih podataka u jednu ili više posebnih svrhu i/ili,\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: " □ obrada se temelji na izričitoj privoli za obradu  osobnih podataka koji otkrivaju rasno ili etničko podrijetlo, politička mišljenja, vjerska ili filozofska uvjerenja ili članstvo u sindikatu te obrada genetskih podataka, biometrijskih podataka u svrhu jedinstvene identifikacije pojedinca, podataka koji se odnose na zdravlje ili podataka o spolnom životu ili seksualnoj orijentaciji pojedinca u jednu ili više određenih svrha i/ili,\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: " □  obrada se temelji na izvršavanju ugovora u kojem sam stranka ili kako bi se poduzele radnje na moj zahtjev prije sklapanja ugovora i/ili,\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: " □ obrada se provodi automatiziranim putem."},
        
          ],
        }
      ]
    }, 
    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
                    { type: "text", content: "3. PODACI ČIJI PRIJENOS ZAHTIJEVAM\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "________________________________________________________________________\r\n"},               
          ],
        }
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    }
  ],
};


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/96_zahtjev_prijenos.ts